import React from "react"
import PropTypes from "prop-types"
import { useCurrentUser } from "hooks/use-current-user"
import { useChildElements } from "../utils/use-child-elements"
import { SettingsButton } from "./settings-button"
import { NewsletterFeed } from "./feeds/newsletter"
import { InstagramFeed } from "./feeds/instagram"

function feedRenderer(source, props) {
  const sources = {
    instagram: () => <InstagramFeed {...props} />,
    newsletter: () => <NewsletterFeed {...props} />
  }
  return sources[source]
}

export function Feed({
  editing,
  mode = "live",
  onClick,
  source,
  onChange,
  element_id,
  ...props
}) {
  const user = useCurrentUser()
  const { children: items } = useChildElements("parent_element_id", element_id)
  return (
    <div className="my-4">
      {editing && (
        <div className="mb-4">
          <SettingsButton onClick={onClick} />
        </div>
      )}
      {feedRenderer(source, {
        ...props,
        onChange,
        editing,
        mode,
        element_id,
        items,
        user,
        useChildElements
      })()}
    </div>
  )
}

Feed.propTypes = {
  editing: PropTypes.bool,
  mode: PropTypes.oneOf(["live", "editing", "preview"]),
  source: PropTypes.string,
  element_id: PropTypes.string,
  onClick: PropTypes.func,
  onChange: PropTypes.func
}

Feed.componentType = "Feed"
